import gql from "graphql-tag";

export default {
  mutation: gql`
    mutation addProcessingUserRole($username: String!, $role: String!) {
      addProcessingUserRole(objectData: { username: $username, role: $role }) {
        success
      }
    }
  `,
  mutationName: "addProcessingUserRole",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingUser/role/addUserRole.js